import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=d2788f66&scoped=true"
import script from "./MFooter.vue?vue&type=script&lang=js"
export * from "./MFooter.vue?vue&type=script&lang=js"
import style0 from "./MFooter.vue?vue&type=style&index=0&id=d2788f66&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2788f66",
  null
  
)

export default component.exports